var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsSliderHor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3C15.0465 3 13.421 4.3989 13.0701 6.25H3.75C3.33579 6.25 3 6.58579 3 7C3 7.41421 3.33579 7.75 3.75 7.75H13.0701C13.421 9.6011 15.0465 11 17 11C19.2098 11 21 9.20985 21 7C21 4.79015 19.2098 3 17 3ZM14.5 7C14.5 5.61859 15.6186 4.5 17 4.5C18.3814 4.5 19.5 5.61859 19.5 7C19.5 8.38141 18.3814 9.5 17 9.5C15.6186 9.5 14.5 8.38141 14.5 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13C7.04653 13 5.421 14.3989 5.07014 16.25H3.75C3.33579 16.25 3 16.5858 3 17C3 17.4142 3.33579 17.75 3.75 17.75H5.07014C5.421 19.6011 7.04653 21 9 21C10.9535 21 12.579 19.6011 12.9299 17.75H20.25C20.6642 17.75 21 17.4142 21 17C21 16.5858 20.6642 16.25 20.25 16.25H12.9299C12.579 14.3989 10.9535 13 9 13ZM6.5 17C6.5 15.6186 7.6186 14.5 9 14.5C10.3814 14.5 11.5 15.6186 11.5 17C11.5 18.3814 10.3814 19.5 9 19.5C7.6186 19.5 6.5 18.3814 6.5 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSliderHor);
export default __webpack_public_path__ + "static/media/settings-slider-hor.e6e6fd21346caf4dac126fbc4f072e08.svg";
export { ForwardRef as ReactComponent };